import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader } from "reactstrap";
import LlmsTxtPipelineSteps from "./LlmsTxtPipelineSteps";

export default function LlmsTxtProcessing({
	status,
	statusLabel,
	lastStage,
	progress,
	pagesTotal,
	pagesExtracted,
}) {
	const navigate = useNavigate();

	return (
		<div className="contentBlock ai-visibility-dashboard llms-txt llms-txt-view">
			<div className="llms-txt__header">
				<div className="llms-txt__header-left">
					<button
						type="button"
						className="llms-txt__back"
						onClick={() => navigate("/aivisibility/llms-txt")}
					>
						<i className="fas fa-arrow-left me-2" />
						Back
					</button>
				</div>
				{statusLabel && (
					<span className="llms-txt__status-badge llms-txt__status-badge--processing">
						<i className="fas fa-spinner fa-spin me-1" />
						{statusLabel}
					</span>
				)}
			</div>

			<Card className="llms-txt__progress-card shadow-sm mt-4 mx-auto">
				<CardHeader className="bg-white border-bottom">
					<h5 className="mb-0">Progress</h5>
				</CardHeader>
				<CardBody>
					<LlmsTxtPipelineSteps
						status={status}
						lastStage={lastStage}
						progress={progress}
						pagesTotal={pagesTotal}
						pagesExtracted={pagesExtracted}
					/>
				</CardBody>
			</Card>
		</div>
	);
}
